/**
 * <ReactSelect />
 *
 *
 * @parent anybody
 * @stateful
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import Select from 'react-select-plus';
import './ReactSelectPlus.scss';

export function reactselect(props) {
  const {
    schema,
    onChange,
    options,
    placeholder,
    disabled,
  } = props;

  const {
    noResultsText,
    direction,
    clearable,
    selectOptions,
    joinValues,
    delimiter,
    multi,
  } = options;

  const {
    name,
  } = schema;

  let value;
  if (multi == true) {
    if (props.value) {
      value = JSON.parse(props.value);
    } else {
      value = []
    }
  } else {
    value = props.value;
  }

  return (
    <ReactSelect
      name={name}
      value={value}
      options={selectOptions}
      direction={direction}
      clearable={clearable}
      placeholder={placeholder}
      joinValues={joinValues}
      delimiter={delimiter}
      multi={multi}
      disabled={disabled}
      onChange={(value)=>{
        if (Array.isArray(value)) {
          onChange(JSON.stringify(value));
        } else {
          onChange(value);
        }
      }}
    />
  );
}

class ReactSelect extends React.Component {
  static propTypes = {

  }

  constructor(props) {
    super(props);
  }

  render() {
    const {
      name,
      value,
      options,
      placeholder,
      noResultsText,
      onChange,
      clearable,
      direction,
      multi,
      delimiter = ';',
      joinValues,
      disabled,
    } = this.props

    return (
      <div className={classnames('react-select-wrapper form-input', 'direction-' + direction || 'down')} >
        <Select
          name={name}
          value={value}
          onChange={(item)=>{
            if (Array.isArray(item)) {
              onChange(item.map(({value})=>{
                return value;
              }));
            } else {
              onChange(!item ? null : item.value);
            }
          }}
          delimiter={delimiter}
          multi={multi}
          clearable={clearable === true}
          options={options}
          placeholder={placeholder}
          noResultsText={noResultsText}
          joinValues={joinValues}
          disabled={disabled}

        />
      </div>
    )
  }
}

export default ReactSelect;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/ReactSelect.js